/**
 * Issue #461: Beta-test feature flags.
 *
 * During the closed beta test all participants must use the automatically
 * generated test accounts. Self-service account creation ("Konto erstellen")
 * and password reset ("Passwort vergessen") are therefore disabled so that
 * testers cannot create their own accounts.
 *
 * Single source of truth: the `REACT_APP_BETA_MODE` environment variable
 * (set in docker-compose.yml, Issue #185). It is `"true"` while the beta test
 * is running. Setting it to anything else after the beta test automatically
 * restores the normal behaviour app-wide — no code changes required.
 */

// true while the closed beta test is running.
export const BETA_TEST_MODE = process.env.REACT_APP_BETA_MODE === 'true';

// Self-service sign-up ("Konto erstellen") is only available outside the beta test.
export const isAccountCreationEnabled = () => !BETA_TEST_MODE;

// Self-service password reset ("Passwort vergessen") is only available outside the beta test.
export const isPasswordResetEnabled = () => !BETA_TEST_MODE;
